var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    enableBackground: "new 0 0 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-39.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(39.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.058433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M18.4,5.9c0,0-0.9,0.8-1.7,1.7c-0.9,0.8,0,2.5,0,2.5l5.1-5l-5.1-5c0,0-0.9,1.7,0,2.5 l1.7,1.7l0.1,0.1H0v1.4h18.5L18.4,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 11.829134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M3.4,4.3l1.7-1.7c0.9-0.8,0-2.5,0-2.5L0,5.1l5.1,5c0,0,0.9-1.7,0-2.5L3.4,5.9L3.3,5.8h18.5 V4.4H3.3L3.4,4.3z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiicon);
export default __webpack_public_path__ + "static/media/api.icon.ad5eb33d.svg";
export { ForwardRef as ReactComponent };